(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap();
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from),
      desc;
    if (entry) return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if ((from && typeof from === "object") || typeof from === "function")
      __getOwnPropNames(from).map(
        (key) =>
          !__hasOwnProp.call(entry, key) &&
          __defProp(entry, key, {
            get: () => from[key],
            enumerable:
              !(desc = __getOwnPropDesc(from, key)) || desc.enumerable,
          }),
      );
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => (all[name] = () => newValue),
      });
  };

  // assets/scripts/details-disclosure.ts
  var exports_details_disclosure = {};
  __export(exports_details_disclosure, {
    HeaderMenu: () => HeaderMenu,
    DetailsDisclosure: () => DetailsDisclosure,
  });

  class DetailsDisclosure extends HTMLElement {
    mainDetailsToggle;
    content;
    animations;
    constructor() {
      super();
      const mainDetailsToggle = this.querySelector("details");
      if (!mainDetailsToggle) {
        throw new Error("DetailsDisclosure requires a details element");
      }
      this.mainDetailsToggle = mainDetailsToggle;
      const summary = this.mainDetailsToggle.querySelector("summary");
      if (!summary) {
        throw new Error("DetailsDisclosure requires a summary element");
      }
      const content = summary.nextElementSibling;
      if (!content) {
        throw new Error("DetailsDisclosure requires content after summary");
      }
      this.content = content;
      this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut);
      this.mainDetailsToggle.addEventListener("toggle", this.onToggle);
    }
    onFocusOut = () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    };
    onToggle = () => {
      if (!this.animations) this.animations = this.content.getAnimations();
      if (this.mainDetailsToggle.hasAttribute("open")) {
        this.animations.forEach((animation) => animation.play());
      } else {
        this.animations.forEach((animation) => animation.cancel());
      }
    };
    close = () => {
      this.mainDetailsToggle.removeAttribute("open");
      const summary = this.mainDetailsToggle.querySelector("summary");
      if (summary) {
        summary.setAttribute("aria-expanded", "false");
      }
    };
  }
  if (!customElements.get("details-disclosure")) {
    customElements.define("details-disclosure", DetailsDisclosure);
  }

  class HeaderMenu extends DetailsDisclosure {
    header;
    constructor() {
      super();
      this.header = document.querySelector(".header-wrapper");
    }
    onToggle = () => {
      if (!this.header) return;
      this.header.preventHide = this.mainDetailsToggle.open;
      if (
        document.documentElement.style.getPropertyValue(
          "--header-bottom-position-desktop",
        ) !== ""
      )
        return;
      document.documentElement.style.setProperty(
        "--header-bottom-position-desktop",
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
      );
    };
  }
  if (!customElements.get("header-menu")) {
    customElements.define("header-menu", HeaderMenu);
  }
})();
